<template>
  <div class="chart-conetent">
    <div class="chart-title">
      <span style="cursor: pointer; margin-right: 20px">内购收入占比</span>
      <el-select v-model="topType" @change="getCharts">
        <el-option :value="5" label="TOP 5"></el-option>
        <el-option :value="10" label="TOP 10"></el-option>
      </el-select>
    </div>
    <div v-loading="chartLoading">
      <div style="display: flex" v-show="allData.length > 0">
        <div style="width: 350px; height: 400px" ref="chartRef"></div>
        <div class="table">
          <el-table
            :data="tableData"
            max-height="346"
            style="width: 100%"
            size="mini"
          >
            <el-table-column prop="date" label="" width="50">
              <template slot-scope="scope">
                <div
                  class="color-block"
                  :style="{ background: colorList[scope.row.index] }"
                ></div>
              </template>
            </el-table-column>
            <el-table-column prop="productName" label="产品" width="200">
            </el-table-column>
            <el-table-column prop="purchaseIncome" label="内购收入($)">
            </el-table-column>
            <el-table-column prop="purchasePer" label="内购收入占比">
              <template slot-scope="scope">
                {{ accMul(scope.row.purchasePer, 100) }} %
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div v-if="allData.length === 0">
        <el-empty style="margin-top: 20px" description="暂无数据"></el-empty>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import { getPurchasePerReport } from "@/api/bi-board";
import { accMul } from "@/utils/math";

export default {
  components: {},
  props: {
    formSearch: Object,
  },
  data() {
    return {
      accMul,
      chartLoading: false,
      myChart: null,
      topType: 10,
      tableData: [],
      allData: [],
      colorList: [
        "#afe31C",
        "#016503",
        "#fd4704",
        "#fc8c03",
        "#ec827f",
        "#02ff81",
        "#1fb1a9",
        "#00fefd",
        "#00befc",
        "#4483b3",
        "#768998",
      ],
    };
  },

  computed: {},

  methods: {
    renderData() {
      let option = {
        color: this.colorList,
        tooltip: {
          trigger: "item",
          formatter: function (params) {
            const text = `<span style="display:inline-block;text-align:right; font-weight:bold; width: 100px`;
            const circle = `<span style="display:inline-block;margin-right:5px;border-radius:50%;width:10px;height:10px;left:5px;background-color:`;
            const result =
              circle +
              params.color +
              `"></span>` +
              params.name +
              "<br />" +
              "支出($)：" +
              text +
              `">${params.value}</span>` +
              "<br />" +
              "支出占比：" +
              text +
              `">${accMul(params.data.purchasePer, 100)}%</span>`;
            return result;
          },
        },
        legend: {
          show: false,
        },
        grid: {
          left: "50",
          right: "50",
        },
        series: [
          {
            name: "收支",
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "10",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: this.allData.map((item) => {
              return {
                value: item.purchaseIncome,
                name: item.productName,
                purchasePer: item.purchasePer,
              };
            }),
          },
        ],
      };
      this.myChart.clear();
      this.myChart.setOption(option);
      this.chartLoading = false;
      this.myChart.resize();
    },
    setLoading(loading) {
      this.chartLoading = loading;
    },
    getCharts() {
      this.chartLoading = true;
      const {
        formdate,
        geo,
        afid,
        platform,
        team,
        mediaList,
        accountGroupCodes,
      } = this.formSearch;
      getPurchasePerReport({
        dateStart: formdate[0],
        dateEnd: formdate[1],
        top: this.topType,
        geo: geo.join(",") || null,
        afid: afid.join(",") || null,
        team: team.join(",") || null,
        platform,
        mediaList,
        accountGroupCodes: accountGroupCodes ? [accountGroupCodes] : undefined,
      }).then((res) => {
        const data = JSON.parse(JSON.stringify(res.data));
        data?.map((item, index) => {
          item.index = index;
          return item;
        });
        this.tableData = data;
        this.allData = data;
        if (data?.length > 0) {
          setTimeout(() => {
            this.myChart?.dispose();
            let chartDom = this.$refs.chartRef;
            let myChart = echarts.init(chartDom);
            window.onresize = myChart.resize;
            this.myChart = myChart;
            this.renderData();
          }, 0);
        } else {
          this.chartLoading = false;
        }
      }).catch((error) => {
        console.error('内购占比加载失败:', error);
      }).finally(() => {
        this.chartLoading = false;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.chart-conetent {
  margin-top: 20px;
  .chart-title {
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 0px;
  }
  .table {
    flex: 1;
    margin-top: 50px;
    /deep/ .el-table td {
      padding: 5px 0;
    }
    /deep/ .el-table th {
      padding: 5px 0;
      height: 40px;
    }
    .color-block {
      width: 19px;
      height: 19px;
      border-radius: 6px;
    }
  }
}
</style>
